import { SortableHandle } from 'react-sortable-hoc';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import TableCellMui, { TableCellProps } from '@mui/material/TableCell';

import IconButton from '@design-system/IconButton';
import DragHandleVertical from '@experimental-components/IconsComponents/DragHandleVertical';

interface RootStylesProps {
  isBorder?: boolean;
  isColorError?: boolean;
  withSideEdges?: boolean;
  hover?: boolean;
  withPadding?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: ({ withPadding }: RootStylesProps) => withPadding,
    borderLeft: ({ withSideEdges }: RootStylesProps) => (withSideEdges ? `1px solid ${theme.palette.darkGrey[5]}` : 0),
    borderBottom: 0,
    borderTop: ({ isBorder }: RootStylesProps) => (isBorder ? `1px solid ${theme.palette.darkGrey[5]}` : 0),
    color: ({ isColorError }: RootStylesProps) =>
      isColorError ? theme.palette.error.main : theme.palette.common.black,
  },
}));

interface Props extends TableCellProps {
  isBorder?: boolean;
  isColorError?: boolean;
  isDraggable?: boolean;
  withSideEdges?: boolean;
  children: React.ReactNode;
  draggableIcon?: React.ReactNode;
  withPadding?: number;
}

function TableCell({
  draggableIcon,
  isBorder = true,
  isColorError = false,
  isDraggable = false,
  withSideEdges = false,
  withPadding = 24,
  children,
  ...others
}: Props) {
  const classes = useStyles({ isBorder, isColorError, withSideEdges, withPadding });

  const DragHandle = SortableHandle(() => (
    <IconButton aria-label="drag" size="small">
      {draggableIcon ?? <DragHandleVertical />}
    </IconButton>
  ));

  return (
    <TableCellMui classes={{ root: classes.root }} {...others}>
      {isDraggable && <DragHandle />}
      {children}
    </TableCellMui>
  );
}

export default TableCell;
